import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\" id=\"avatar\"><a href=\"#avatar\"></a> Avatar </h1><div class=\"py-5\"> Refer to below example to use Symbol for avatar image display: </div><div class=\"py-5\"><div class=\"rounded border p-10 pb-0 d-flex flex-wrap\"><div class=\"symbol symbol-50px me-10 mb-10\"><img src=\"media/avatars/150-1.jpg\" alt=\"\"></div><div class=\"symbol symbol-50px me-10 mb-10\"><img src=\"media/avatars/150-2.jpg\" alt=\"\"></div><div class=\"symbol symbol-50px me-10 mb-10\"><img src=\"media/avatars/150-3.jpg\" alt=\"\"></div><div class=\"symbol symbol-50px me-10 mb-10\"><img src=\"media/avatars/150-4.jpg\" alt=\"\"></div><div class=\"symbol symbol-50px me-10 mb-10\"><img src=\"media/avatars/150-5.jpg\" alt=\"\"></div><div class=\"symbol symbol-50px me-10 mb-10\"><img src=\"media/avatars/150-6.jpg\" alt=\"\"></div></div></div>", 3)
const _hoisted_5 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`
        <div class="symbol symbol-50px">
          <img src="assets/media/avatars/150-1.jpg" alt="" />
        </div>
        `), 1)
        ]),
        _: 1
      })
    ])
  ]))
}